document.addEventListener("DOMContentLoaded", function () {

    function validateInitials(e) {
        const input = document.getElementById("custom_initials");
        if (!input) return true;

        const error = document.getElementById("initials-error");

        if (input.value.trim() === "") {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }

            error.style.display = "block";
            input.style.borderColor = "#d93025";
            input.focus();

            return false;
        }

        error.style.display = "none";
        input.style.borderColor = "#ddd";
        return true;
    }

    // // Add to Cart
    // document.addEventListener("click", function (e) {
    //     if (e.target.closest('button[name="add"]')) {
    //         validateInitials(e);
    //     }
    // }, true);

    // // Buy Now (Dynamic Checkout)
    // document.addEventListener("click", function (e) {
    //     if (
    //         e.target.closest('.shopify-payment-button__button') ||
    //         e.target.closest('.shopify-payment-button button')
    //     ) {
    //         validateInitials(e);
    //     }
    // }, true);

});
